import React from 'react'
import './Style/Header.css'
import Logo from '../Image/Logo.png'
function Header({info,product,date,customer}) {
  return <div className='invoice-header md:px-10 px-0'>

      <div className='grid w-full grid-cols-2'>

          <div className='col-span-1 py-10 px-5 header-logo'>
            <div>
                <img src={Logo} alt=''className='w-40'/>
                <p className='font-black mt-1 text-sm'>Clothing Co.</p>
            </div>
            <div className='mt-6'>
                  <p className='text-sm mt-12 address'> Address : {info.connection.address}  </p>
                  <p className='text-sm mt-3'> Number : {info.connection.number}</p>
                  <p className='text-sm mt-3'> Email : {info.connection.email}</p>
            </div>
          </div>

          <div className='col-span-1 text-right header-info w-full md:py-10 py-10 md:px-5 px-2 md:justify-self-end justify-self-start'>
              <p> Invoice No: {product.invoiceNumber} </p>
              <p> Date : {date} </p>

              <div className='md:py-10 py-2'>
                  <p className='font-bold text-lg'> Invoice To :  </p>
                  <p> {customer.info.name} </p>
                  <p> {customer.info.address} </p>
                  <p> {customer.info.number} </p>
                  <p> {customer.info.email} </p>
              </div>

          </div>    

      </div>

  </div>
}

export default Header